<!--
 * @Descripttion: 备忘提醒 - 新建/编辑备忘页
 * @version:
 * @Author: geory
 * @Date: 2026-08-14 10:00:00
 * @LastEditors: geory
 * @LastEditTime: 2026-08-14 20:30:00
-->
<template>
    <div class="memoEditOverlay" :style="{'top':topOffset+'px','height':'calc(100% - '+topOffset+'px)'}">
        <div class="memoEditTopBar">
            <div class="memoEditBack" @click="cancelClick">
                <img src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png" />
                <span>返回</span>
            </div>
            <div class="memoEditTitle">{{memoData ? '编辑备忘' : '新建备忘'}}</div>
            <div class="memoEditTopSave" @click="saveClick">保存</div>
        </div>
        <div class="memoEditScroll">
            <textarea class="memoEditInput" v-model="content" placeholder="输入备忘内容"></textarea>

            <!-- 提醒设置（与设提醒弹窗共用同一组件） -->
            <div class="memoEditSectionTitle">提醒设置</div>
            <memo-remind-setting v-model="remindSetting"></memo-remind-setting>

            <!-- 图片附件 -->
            <div class="memoEditSectionTitle">图片附件</div>
            <div class="memoEditImgList">
                <div v-for="(img,idx) in imageList" :key="'memoEditImg'+img.id" class="memoEditImgItem">
                    <img :src="img.path || img.url" />
                    <span class="memoEditImgDel" @click="delImage(idx)">×</span>
                </div>
                <div class="memoEditImgAdd" @click="chooseImage">
                    <span class="memoEditImgAddPlus">+</span>
                    <span>图片</span>
                </div>
            </div>
        </div>
        <div class="memoEditBottomBar">
            <div class="memoEditCancelBtn" @click="cancelClick">取消</div>
            <div class="memoEditSaveBtn" @click="saveClick">保存</div>
        </div>
        <input type="file" ref="imgInput" accept="image/*" multiple hidden @change="imgChange" />
    </div>
</template>

<script>
    import qiniuService from "@/service/qiniuService"
    import memoRemindSetting from '@/components/MemoRemindSetting'
    import {
        buildMemoIcsFromItem,
        downloadMemoIcs
    } from '@/service/memoCalendarService'
    import {
        getSyncCalendarDefault,
        isWindowsPlatform
    } from '@/service/memoRemindService'

    function pad(n) {
        return n < 10 ? "0" + n : "" + n;
    }

    function formatDate(date) {
        return (
            date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) +
            " " + pad(date.getHours()) + ":" + pad(date.getMinutes())
        );
    }

    export default {
        name: "MemoEdit",
        props: {
            //编辑时传入备忘数据，新建传null
            memoData: {
                type: Object,
                default: null
            },
            //顶部偏移（独立窗口页在Electron下为窗口控制栏让位）
            topOffset: {
                type: Number,
                default: 0
            }
        },
        components: {
            memoRemindSetting
        },
        watch: {
            //独立窗口中 memoData 通过IPC异步到达，需要监听更新
            memoData: {
                handler() {
                    this.initFromMemoData();
                },
                deep: false,
            },
        },
        data() {
            return {
                content: "",
                imageList: [], // {file,path,url,id,waitUpload}
                //提醒设置：{remindType,notRepeatTime,byDayTime,byMonthDay,byWeekDay,syncCalendar}
                remindSetting: this.emptyRemindSetting(),
                saving: false,
            }
        },
        methods: {
            emptyRemindSetting() {
                return {
                    remindType: -1,
                    notRepeatTime: 0,
                    byDayTime: 0,
                    byMonthDay: 1,
                    byWeekDay: [],
                    syncCalendar: getSyncCalendarDefault(),
                };
            },
            initFromMemoData() {
                const md = this.memoData;
                //先重置（窗口复用时清掉上次编辑的残留）
                this.content = "";
                this.imageList = [];
                this.remindSetting = this.emptyRemindSetting();
                if (!md) {
                    return;
                }
                this.content = md.content || "";
                //已有多媒体
                let media = [];
                if (md.rawMediaArray) {
                    try {
                        media = JSON.parse(md.rawMediaArray);
                    } catch (e) {
                        media = [];
                    }
                }
                if (Array.isArray(media)) {
                    media.forEach((m, idx) => {
                        if (m && m.type == 1 && m.url) {
                            this.imageList.push({
                                url: m.url,
                                id: Date.now() + idx,
                                waitUpload: false,
                            })
                        }
                    })
                }
                //提醒数据
                let byWeekDay = [];
                if (md.byWeekDay) {
                    try {
                        const days = Array.isArray(md.byWeekDay) ? md.byWeekDay : JSON.parse(md
                            .byWeekDay);
                        if (Array.isArray(days)) {
                            byWeekDay = days.map(Number).filter((n) => n >= 1 && n <= 7);
                        }
                    } catch (e) {}
                }
                this.remindSetting = {
                    remindType: md.remindType != null ? Number(md.remindType) : -1,
                    notRepeatTime: Number(md.notRepeatTime) || 0,
                    byDayTime: Number(md.byDayTime) || 0,
                    byMonthDay: Number(md.byMonthDay) || 1,
                    byWeekDay: byWeekDay,
                    syncCalendar: getSyncCalendarDefault(),
                };
            },
            cancelClick() {
                if (this.saving) {
                    return;
                }
                this.$emit('close');
            },
            chooseImage() {
                if (this.saving) {
                    return;
                }
                this.$refs.imgInput.click();
            },
            imgChange(e) {
                let files = e.target.files;
                for (let idx = 0; idx < files.length; idx++) {
                    let file = files[idx];
                    if (!file.type.includes("image")) {
                        continue;
                    }
                    let fileExtension = file.name.split('.').pop().toLowerCase();
                    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].indexOf(fileExtension) < 0) {
                        this.$message({
                            message: "不支持上传" + fileExtension + "类型图片",
                            type: 'warning'
                        });
                        continue;
                    }
                    this.imageList.push({
                        file: file,
                        path: this.$common.getBaseURL(file),
                        id: new Date().getTime() + idx,
                        waitUpload: true,
                    })
                }
                this.$refs.imgInput.value = '';
            },
            delImage(idx) {
                if (this.saving) {
                    return;
                }
                this.imageList.splice(idx, 1);
            },
            //上传本地图片到七牛云
            async uploadImages() {
                let waitUploadList = this.imageList.filter((val) => {
                    return val.waitUpload
                })
                if (!waitUploadList.length) {
                    return;
                }
                let tokenParams = {
                    functionType: 2,
                    targetId: localStorage.getItem("edujia:group:web:userid")
                }
                let imageSuffix = [];
                waitUploadList.forEach((file) => {
                    imageSuffix.push(file.file.type.split("/")[1])
                })
                if (imageSuffix.length) {
                    tokenParams.imageSuffix = JSON.stringify(imageSuffix)
                }
                console.log("memo getFileUploadToken params:", tokenParams);
                let enResp = await this.$http.getFileUploadToken(tokenParams);
                if (enResp.code != 200) {
                    throw new Error("获取上传凭证失败");
                }
                let key = localStorage.getItem("edujia:group:web:key");
                let data = key ? JSON.parse(this.$common.decrypt(enResp.data, key)) : JSON.parse(this
                    .$common.decrypt(enResp.data));
                console.log("memo getFileUploadToken res:", data);
                let imageDomain = data.object.imageDomain;
                let resultArr = await qiniuService.uploadImgArr(data.object.imageToken, waitUploadList);
                console.log('memo upload result ==' + JSON.stringify(resultArr));
                resultArr.forEach((val) => {
                    this.imageList.forEach((file) => {
                        if (file.id == val.id) {
                            file.url = imageDomain + val.url.key;
                            file.waitUpload = false;
                        }
                    })
                })
            },
            //同步到系统日历（Windows版已停用：任何场景都不提示、不同步）
            syncToCalendar(item) {
                if (isWindowsPlatform()) {
                    return;
                }
                const ics = buildMemoIcsFromItem(item);
                if (!ics) {
                    return;
                }
                if (this.$common.isElectron() && window.require) {
                    const {
                        ipcRenderer
                    } = window.require('electron');
                    ipcRenderer.once('memoSyncCalendarResult', (e, res) => {
                        if (res && !res.ok && !res.silent) {
                            this.$message({
                                message: '静默写入系统日历失败，已改为打开日历文件导入；如弹出授权窗口请点击允许',
                                type: 'warning'
                            });
                        }
                    });
                    ipcRenderer.send('memoSyncCalendar', JSON.stringify({
                        memoId: item.id,
                        title: item.content,
                        //编辑前旧内容：同步时主进程会一并删除旧标题的日历事件
                        oldTitle: this.memoData && this.memoData.content ? this.memoData.content :
                            "",
                        //仅不重复类型走mac静默写入；重复类型由主进程打开ics导入
                        startTime: item.remindType === 0 ? this.remindDateStr(item.notRepeatTime) :
                            "",
                        ics: ics,
                        //提醒配置（Windows端Outlook COM写入使用）
                        remind: {
                            remindType: item.remindType,
                            notRepeatTime: item.notRepeatTime || 0,
                            byDayTime: item.byDayTime || 0,
                            byMonthDay: item.byMonthDay || 0,
                            byWeekDay: item.byWeekDay || [],
                        },
                    }));
                } else {
                    downloadMemoIcs(item.content, ics);
                }
            },
            remindDateStr(ms) {
                const d = new Date(Number(ms));
                if (isNaN(d.getTime())) {
                    return "";
                }
                return formatDate(d);
            },
            async saveClick() {
                if (this.saving) {
                    return;
                }
                if (!this.content.trim()) {
                    this.$message({
                        message: '请输入备忘内容',
                        type: 'warning'
                    });
                    return;
                }
                const remind = this.remindSetting;
                if (remind.remindType === 0 && !remind.notRepeatTime) {
                    this.$message({
                        message: '请选择提醒时间',
                        type: 'warning'
                    });
                    return;
                }
                if (remind.remindType === 2 && !(remind.byWeekDay && remind.byWeekDay.length)) {
                    this.$message({
                        message: '请选择每周提醒的日期',
                        type: 'warning'
                    });
                    return;
                }
                this.saving = true;
                let loading = this.$loading.service({
                    lock: true,
                    text: '保存中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    fullscreen: true
                });
                try {
                    await this.uploadImages();
                    let mediaArray = this.imageList.map((img) => {
                        return {
                            type: 1,
                            url: img.url
                        }
                    }).filter((m) => {
                        return !!m.url
                    })
                    let params = {
                        content: this.content.trim(),
                        remindType: remind.remindType,
                        notRepeatTime: remind.notRepeatTime || 0,
                        byDayTime: remind.byDayTime || 0,
                        byMonthDay: remind.byMonthDay || 0,
                        byWeekDay: remind.byWeekDay && remind.byWeekDay.length ? JSON.stringify(remind
                            .byWeekDay) : "",
                        mediaArray: JSON.stringify(mediaArray),
                    };
                    if (this.memoData && this.memoData.id) {
                        params.id = this.memoData.id;
                    }
                    console.log("memoSave params:", params);
                    let resp = await this.$http.memoSave(params)
                    if (resp && resp.code == 200) {
                        //需要同步日历（Windows版停用系统日历同步，跳过）
                        if (remind.syncCalendar && remind.remindType != -1 && !isWindowsPlatform()) {
                            const savedId = (resp.data && resp.data.object && resp.data.object.id) ||
                                params.id || Date.now();
                            this.syncToCalendar({
                                id: savedId,
                                content: params.content,
                                remindType: remind.remindType,
                                notRepeatTime: remind.notRepeatTime,
                                byDayTime: remind.byDayTime,
                                byMonthDay: remind.byMonthDay,
                                byWeekDay: remind.byWeekDay,
                            });
                        }
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$emit('saved');
                    } else {
                        this.$message({
                            message: (resp && resp.message) || '保存失败',
                            type: 'warning'
                        });
                    }
                } catch (e) {
                    console.log("memoSave error:", e);
                    this.$message({
                        message: '保存失败，请重试',
                        type: 'warning'
                    });
                }
                this.saving = false;
                loading.close();
            },
        },
        created() {
            this.initFromMemoData();
        },
    }
</script>

<style scoped>
    .memoEditOverlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        z-index: 1200;
        display: flex;
        flex-direction: column;
    }

    .memoEditTopBar {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        border-bottom: 1px solid #F0F0F0;
        flex-shrink: 0;
    }

    .memoEditBack {
        display: flex;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
    }

    .memoEditBack img {
        width: 25px;
        height: 25px;
        margin-right: 2px;
    }

    .memoEditTitle {
        font-size: 16px;
        font-weight: bold;
        color: #3C3C3C;
    }

    .memoEditTopSave {
        font-size: 14px;
        color: #4A90E2;
        cursor: pointer;
        user-select: none;
    }

    .memoEditScroll {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 16px;
    }

    .memoEditScroll::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .memoEditInput {
        width: 100%;
        min-height: 140px;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        padding: 10px 12px;
        font-size: 14px;
        color: #3C3C3C;
        line-height: 22px;
        box-sizing: border-box;
        resize: vertical;
        outline: none;
        font-family: inherit;
        user-select: text;
    }

    .memoEditInput:focus {
        border-color: #FB5D5C;
    }

    .memoEditInput::placeholder {
        color: #999999;
    }

    .memoEditSectionTitle {
        font-size: 14px;
        font-weight: 500;
        color: #3C3C3C;
        margin: 16px 0 8px;
    }

    .memoEditImgList {
        display: flex;
        flex-wrap: wrap;
    }

    .memoEditImgItem {
        width: 64px;
        height: 64px;
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 10px;
        position: relative;
    }

    .memoEditImgItem img {
        width: 64px;
        height: 64px;
        object-fit: cover;
        border-radius: 4px;
        background-color: #F5F6F6;
    }

    .memoEditImgDel {
        position: absolute;
        top: -6px;
        right: -6px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.55);
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }

    .memoEditImgAdd {
        width: 64px;
        height: 64px;
        border: 1px dashed #C9C9C9;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #999999;
        font-size: 12px;
        cursor: pointer;
        user-select: none;
        box-sizing: border-box;
    }

    .memoEditImgAdd:hover {
        border-color: #FB5D5C;
        color: #FB5D5C;
    }

    .memoEditImgAddPlus {
        font-size: 20px;
        line-height: 1;
        margin-bottom: 4px;
    }

    .memoEditBottomBar {
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 16px;
        border-top: 1px solid #F0F0F0;
        flex-shrink: 0;
    }

    .memoEditCancelBtn {
        width: 88px;
        height: 32px;
        border: 1px solid #C9C9C9;
        border-radius: 4px;
        color: #666666;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        margin-right: 12px;
    }

    .memoEditSaveBtn {
        width: 88px;
        height: 32px;
        background-color: #FB5D5C;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
    }

    .memoEditSaveBtn:hover {
        background-color: #f04a49;
    }
</style>
